import {
	isRejectedWithValue,
	Middleware,
	MiddlewareAPI,
} from '@reduxjs/toolkit'
import { modalCreators } from '../ducks/modal'

const shouldBypassError = (action: any): boolean => {
	const { type, payload } = action
	const message = payload?.data?.message

	const rules = [
		type === 'authRepository/executeMutation/rejected' &&
			message === 'Invalid JWT',
		type === 'profileAwariRepository/executeQuery/rejected',
		type === 'mentorshipsRepository/executeQuery/rejected' &&
			message === 'student not found',
		type === 'creditsRepository/executeQuery/rejected' &&
			message === 'student not found',
		type === 'modalsMentorshipsRepository/executeQuery/rejected' &&
			message === 'student not found',
	]

	return rules.some(Boolean)
}

export const errorMiddleware: Middleware =
	(api: MiddlewareAPI) => (next) => (action: any) => {
		if (isRejectedWithValue(action)) {
			if (shouldBypassError(action)) {
				return next(action) // Ignora o middleware se a condição for atendida
			}

			const error = {
				title: 'Ocorreu um erro',
				buttonLabel: 'Fechar',
				message: (() => {
					if (action.payload.data?.errors) {
						return `Error on ${action.payload.data.errors[0].field}: ${action.payload.data.errors[0].message}`
					}

					if (action.payload.data?.message) {
						return action.payload.data.message
					}

					if (action.payload.data?.length) {
						return action.payload.data[0].message
					}

					if (action.payload.data?.err) {
						return 'Problema na validação (dados inconsistentes)'
					}

					return 'Ocorreu um erro desconhecido'
				})(),
			}

			api.dispatch(
				modalCreators.openModal({
					name: 'statusModal',
					type: 'error',
					modalInfo: error,
				})
			)
		}

		return next(action) // Sempre continua o fluxo
	}
